module.exports = __webpack_public_path__ + "img/growth_c.b7f6d41c.svg";